import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { DistributorService } from '../../../../distributor.service';
import { IDetailVerification__DistributorInformation } from '../../../../interfaces/detail-verification.interface';
import { ICardVerificationForm } from '../../../../interfaces/detail-registration.interface';
import { DetailRegistrationDistributorService } from '../../detail-registration/detail-registration.service';
import {
  creditBillingBodyData,
  creditCeilingBodyData,
  distributorDetailBodyData,
  documentBodyData,
  EnumCardVerificationForm,
  EnumCardVerificationSection,
  managerBodyData,
  npwpBodyData,
  ownerBodyData,
  scopeBodyData,
} from '../../detail-registration/distributor-data/distributor-data.data';

@Component({
  selector: 'app-verification-tab-informasi-distributor',
  templateUrl: './verification-tab-informasi-distributor.component.html',
  styleUrls: ['./verification-tab-informasi-distributor.component.scss'],
})
export class VerificationTabInformasiDistributorComponent implements OnInit {
  isLoading = new BehaviorSubject(false);
  snapshotParams!: Params;
  detailSubject = new BehaviorSubject({} as IDetailVerification__DistributorInformation);

  //sections data
  scopeSubject = new BehaviorSubject<ICardVerificationForm[]>([]);
  distributorDetailSubject = new BehaviorSubject<ICardVerificationForm[]>([]);
  ownerSubject = new BehaviorSubject<ICardVerificationForm[]>([]);
  managerSubject = new BehaviorSubject<ICardVerificationForm[]>([]);
  npwpInfoSubject = new BehaviorSubject<ICardVerificationForm[]>([]);
  creditCeilingSubject = new BehaviorSubject<ICardVerificationForm[]>([]);
  creditBillingSubject = new BehaviorSubject<ICardVerificationForm[]>([]);
  dokumenPendaftaranSubject = new BehaviorSubject<ICardVerificationForm[]>([]);

  constructor(private activeRoute: ActivatedRoute, private distributorService: DistributorService, private registrationService: DetailRegistrationDistributorService) {}

  ngOnInit(): void {
    this.snapshotParams = this.activeRoute.snapshot.params;
    this.getDetail();
  }

  getDetail() {
    this.isLoading.next(true);
    this.distributorService.getDetailVerificationDistributorInformation(this.snapshotParams.id).subscribe((resp) => {
      if (!resp) return;
      this.detailSubject.next(resp && resp.data);
      this.generateBodyData();
      this.isLoading.next(false);
    });
  }

  generateBodyData() {
    const { scope, distributor_detail, owner, manager, npwp_information, document, credit_ceiling_granted, credit_billing } = this.detailSubject.value;

    const mappingConfig = [
      { data: scope, subject: this.scopeSubject, bodyData: scopeBodyData },
      { data: distributor_detail, subject: this.distributorDetailSubject, bodyData: distributorDetailBodyData },
      { data: owner, subject: this.ownerSubject, bodyData: ownerBodyData },
      { data: manager, subject: this.managerSubject, bodyData: managerBodyData },
      { data: npwp_information, subject: this.npwpInfoSubject, bodyData: npwpBodyData },
      {
        data: credit_ceiling_granted,
        subject: this.creditCeilingSubject,
        bodyData: (mapped: any) => creditCeilingBodyData(mapped.current_data),
      },
      {
        data: credit_billing,
        subject: this.creditBillingSubject,
        bodyData: (mapped: any) => creditBillingBodyData(mapped.current_data),
      },
      { data: document, subject: this.dokumenPendaftaranSubject, bodyData: documentBodyData },
    ];

    mappingConfig.forEach(({ data, subject, bodyData }) => {
      const mappedData = this.staticMapperDataCard(data);
      const finalBodyData = typeof bodyData === 'function' ? bodyData(mappedData) : bodyData;
      subject.next(this.registrationService.generateBodyData(mappedData, finalBodyData));
    });
  }

  staticMapperDataCard<T>(data: T) {
    return {
      revision_note: '',
      revision_data: null,
      current_data: data,
    };
  }

  protected readonly EnumCardVerificationSection = EnumCardVerificationSection;
  protected readonly EnumCardVerificationForm = EnumCardVerificationForm;
}
